/** A path that stays inside the app: starts with one slash, not `//` (protocol-relative) or a scheme. */
export function isAppPath(path: unknown): path is string {
  return typeof path === 'string' && path.startsWith('/') && !path.startsWith('//')
}

/** The first value of a route query param when it is a safe in-app path, else null. */
export function safeRedirect(query: unknown): string | null {
  const value = Array.isArray(query) ? query[0] : query
  return isAppPath(value) ? value : null
}
